import { Controller } from "@hotwired/stimulus";
import TomSelect from "tom-select";

// Connects to data-controller="forms--multi-select"
export default class extends Controller {
  connect() {
    if (this.element.tomselect) return;
    this.select = new TomSelect(this.element, {
      plugins: ["remove_button"],
    });
  }

  disconnect() {
    if (this.select) {
      this.select.destroy();
      this.select = null;
    }
  }
}
